'use strict';

var einsteinUtils = require('core/components/einsteinUtils');
var productTile = require('./productTile');
var abSlider = require('core/components/slider');

module.exports = {};

/**
 * Copied from autobahn_core to remove slider title and border style when there's no product recommendations.
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 * @param {Object} e jquery event
 * @returns {Object} jquery targets
 */
module.exports.loadRecommendations = function (e) {
    const _this = this;

     if (typeof einsteinUtils.getEinsteinUtils() !== 'object') {
        if (document.readyState !== 'complete') {
            (document.readyState !== 'interactive' ? document : window)
                .addEventListener(document.readyState === 'loading' ? 'DOMContentLoaded' : 'load', () => {module.exports.loadRecommendations.apply(_this, Array.from(arguments))});
        } else {
            window.console?.error('Einstien Utilities are not available.', document.readyState + '');
        }
    } else {
        var $context = $(_this);
        var $recommendationTargets = $context.hasClass('.einstein-data') ? $context : $context.find('.einstein-data');

        return $recommendationTargets.each(function () {
            var $recTrigger = $(this);
            var data = $recTrigger.data() || {};
            var asyncUrl = data.url;

            einsteinUtils.getRecommendations(data, function (einsteinResponse) {
                var response = einsteinUtils.interpretResponse(data, einsteinResponse);

                // Add replace content URL
                $.each(response, function (i, rec) {
                    if (!rec || !rec.id) return null;

                    var pidURL = asyncUrl;
                    pidURL += (pidURL.indexOf('?') === -1 ? '?' : '&') + 'pid=' + rec.id;
                    $recTrigger.find('.product[data-pid="placeholder"]:not([data-replace-content])')
                        .first()
                        .attr('data-replace-content', pidURL); //Must be attr to allow productTile.js async selector rule to catch recommendation
                });

                // Remove empty slides
                $recTrigger.find('.slide:has(.product[data-pid="placeholder"]:not([data-replace-content]))').remove();

                // Prepare Slider Container
                var $sliderContainer = $recTrigger.closest('.slider-container').removeClass('delay-init');

                // on cart page, hide the title when there's no slides
                if ($('[data-action="Cart-Show"]').length > 0 && $recTrigger.children('.slide').length < 1) {
                    $sliderContainer.prev('.slider-title').addClass('d-none');
                    $sliderContainer.closest('.cart-recommendations').css({ 'border': 'none' });
                }

                productTile.init($recTrigger.find('.product'), function (status) {
                    // Re Initialize sliders to account for TileInclude Errors
                    var tns = status.errors > 0 ? $sliderContainer.data('tns') : null;

                    if (tns) {
                        tns.destroy();
                        tns = tns.rebuild();
                        $sliderContainer.data('tns', tns);
                    }
                });

                // Initialize sliders
                abSlider.initializeSliders($sliderContainer.parent());
            });
        });
    }
}

module.exports.init = function (context) {
    // Re-triggerable dom event
    $(document).off('load.einstein')
        .on('load.einstein', module.exports.loadRecommendations);

    context = context && 'trigger' in context ? context : $(document);

    return context.triggerHandler('load.einstein');
};
